const name = {
  firstName: "Aman",
  firstNameHindi: "अमन",
  lastName: "Shekhar",
  fullName: `Aman Shekhar`,
};

const email = "aman.shekhar1995@gmail.com";

export { name, email };
